// extracted by mini-css-extract-plugin
export default {"searchBar":"Nav_searchBar__bU02N"};